import {api, apiWithoutToken} from "./api";
import {AUTH_PASSWORD_CHANGE, AUTH_TOKEN, AUTH_UPDATE_AVATAR, AUTH_UPDATE_USER} from "../mock/URLs";

type LoginValues = {
  phone: string
  password: string
}

export const login = async (values:LoginValues) => {
  try {
    const res = await apiWithoutToken.post(AUTH_TOKEN, values)
    return res
  } catch (e) {
    throw e
  }
}

export const changePassword = async (values:{
  old_password: string
  new_password: string
  new_password_confirm: string
}) => {
  try {
    const {data} = await api.post(AUTH_PASSWORD_CHANGE, values)
    return data
  } catch (e) {
    throw e
  }
}

export const updateProfile = async (values:FormData) => {
  try {
    const {data} = await api.patch(AUTH_UPDATE_USER, values)
    return data
  } catch (e) {
    throw e
  }
}

export const updateAvatar = async (values:FormData) => {
  try {
    const {data} = await api.patch(AUTH_UPDATE_AVATAR, values)
    return data
  } catch (e) {
    throw e
  }
}